import React, { useState, useEffect } from 'react';
import logo from '../../images/keralty.png';
import { QRCodeCanvas } from "qrcode.react";
const Pix = require("../pix/Pix");

const DonationSection = () => {
  const [valor, setValor] = useState(null);
  const [payload, setPayload] = useState("");
  const [pixCopied, setPixCopied] = useState("Copiar PIX Copia e Cola");

  const chavePix = "CHAVE PIX AQUI";
  const nome = "NOME DO TITULAR DA CHAVE PIX";
  const cidade = "SAO PAULO";

  const txid = valor ? `DOE${Date.now()}` : "";

  useEffect(() => {
    if (valor != null && !isNaN(valor)) {
      const pix = new Pix(
        chavePix,
        "Doacao keralty",
        nome,
        cidade,
        txid,
        valor
      );
      setPayload(pix.getPayload());
      setPixCopied("Copiar PIX Copia e Cola");
    } else {
      setPayload("");
    }
  }, [valor]);

  const handleCopy = () => {
    if (!payload) return;
    navigator.clipboard.writeText(payload);
    setPixCopied("Pix copiado para a área de transferência");
  };

  const handleInputChange = (e) => {
    const value = parseFloat(e.target.value);
    setValor(isNaN(value) ? null : value);
  };

  return (
    <div className="flex flex-col bg-third">
      <div className="p-8 flex flex-col md:flex-row items-center justify-center">
        <div className="flex flex-col md:flex-row items-center max-w-7xl mx-auto w-full">
          <div className="flex flex-col items-center md:items-start text-center md:text-left flex-1 p-6">
            <img src={logo} alt="Logo Keralty" className="w-16 mb-4" />
            <h2 className="text-white text-3xl font-rubik md:text-5xl font-bold leading-tight">
              Transforme sonhos hoje: <br />
              sua doação pode <br />
              mudar vidas!
            </h2>
          </div>

          <div className="text-white text-center md:text-right md:mr-8 text-sm max-w-xs">
            <p className="mb-2 font-rubik text-2xl">Para fazer um pix, escolha ou insira um valor abaixo, abra seu app do banco e transfira escaneando o QR Code ou colando o Cix Copia e Cola</p>
          </div>
        </div>
      </div>

      <div className="p-6 flex flex-col items-center gap-4 max-w-md mx-auto">
        <h2 className="text-4xl font-bold font-rubik text-white text-center">
          Faça uma doação via PIX
        </h2>

        <div className="flex gap-2">
          {[20, 50, 75].map((v) => (
            <button
              key={v}
              onClick={() => setValor(v)}
              className={`px-8 py-5 rounded-lg shadow hover:bg-slate-100 hover:text-primary ${
                valor === v ? "text-primary bg-white" : "bg-primary text-white"
              }`}
            >
              R$ {v}
            </button>
          ))}
        </div>

        <input
          type="number"
          step="0.01"
          placeholder="Ou insira outro valor"
          value={valor || ""}
          onChange={handleInputChange}
          className="border rounded p-2 w-full text-center"
        />

        {payload && (
          <div className="flex flex-col items-center gap-2">
            <QRCodeCanvas value={payload} size={200} includeMargin />
            <button
              onClick={handleCopy}
              className="mt-2 px-4 py-2 bg-primary hover:bg-slate-100 hover:text-primary text-white rounded-lg shadow"
            >
              {pixCopied}
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default DonationSection;
